import { Switch } from '@components/ui/switch';
import { CampaignStatus } from '@givz/core-client';
import {
  useActivateIncentive,
  useDeactivateIncentive,
} from '@queries/incentives';
import { FunctionComponent, useEffect, useState } from 'react';

export type ToggleIncentiveProps = {
  gid: string;
  initialStatus?: CampaignStatus;
};

export const ToggleIncentive: FunctionComponent<ToggleIncentiveProps> = (
  props,
) => {
  const { gid, initialStatus } = props;
  const [checked, setChecked] = useState(
    initialStatus === CampaignStatus.Active,
  );

  const activateIncentive = useActivateIncentive();
  const deactivateIncentive = useDeactivateIncentive();

  useEffect(() => {
    setChecked(initialStatus === CampaignStatus.Active);
  }, [initialStatus]);

  const onChangeItemChecked = (_event: any, checked: boolean) => {
    const toggleIncentive = checked
      ? activateIncentive.mutate
      : deactivateIncentive.mutate;
    toggleIncentive({ body: {}, gid });
    setChecked(checked);
  };

  return (
    <Switch
      offLabel="Off"
      onLabel="On"
      labelProps={{ labelPlacement: 'start' }}
      onChange={onChangeItemChecked}
      checked={checked}
    />
  );
};
